export default "__VITE_ASSET__o_194igH__"